module.exports = __webpack_public_path__ + "img/gs3.a831f979.svg";